export const meta = (...parts) => parts.filter(Boolean).join(" · ");
